var crypto = require('crypto');
const Hosts = require('../src/Hosts');
//const axios = require('axios');
//import Resizer from "react-image-file-resizer";
var Resizer = require('react-image-file-resizer');

export const requests = async (url, request_type, body_data) => {

    let localtoken = (JSON.parse(localStorage.getItem('token')))
    //console.log('TOKEN NO UTILS:', localtoken)
    const requestOptions = {
        method: request_type,

        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + (localtoken === null ? '' : localtoken.token)
        },
        body: JSON.stringify(body_data)

    }
    // console.log('----------->', localtoken)
    // console.log('----------->', url)
    // console.log('----------->', requestOptions)

    return await fetch(url, requestOptions).then(response => response.json())
    //.then(res => { //console.log(res); return res })
}


export const requests_file = async (url, request_type, body_data) => {

    let localtoken = (JSON.parse(localStorage.getItem('token')))
    //console.log('TOKEN NO UTILS:', localtoken)

    const requestOptions = {
        method: request_type,
        headers: {
            'Authorization': 'Bearer ' + (localtoken === null ? '' : localtoken.token)
        },
        body: body_data

    }
    //console.log(localtoken)
    return await fetch(url, requestOptions).then(response => response.json())
    //.then(res => { //console.log(res); return res })
}


export const simpleGet = async (url) => {
    //'Content-Type': '*/*',
    const requestOptions = {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Access-Control-Allow-Origin': '*'
        },
    }
    // console.log('----------->', localtoken)
    // console.log('----------->', url)
    // console.log('----------->', requestOptions)

    return await fetch(url, requestOptions).then(response => response.blob())
}

export const reqGET = async (url) => {
    return await requests(url, 'GET')
}

export const reqPOST = async (url, data) => {
    return await requests(url, 'POST', data)
}

export const reqPUT = async (url, data) => {
    return await requests(url, 'PUT', data)
}

export const reqDELETE = async (url, data) => {
    return await requests(url, 'DELETE', data)
}

export const reqFILE = async (url, data) => {
    return await requests_file(url, 'POST', data)
}

export const load_countries_pt = async () => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/langpt/list`)
}


export const load_countries_en = async () => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/langen/list`)
}


export const load_countries = async (lang) => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/lang${lang}/list`)
}

export const load_districts_pt = async () => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/pt/districts`)
}

export const load_cities_of_district_pt = async district => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/pt/citiesofdistrict/${district}`)
}

export const load_district_of_city_pt = async city => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/pt/districtofcity/${city}`)
}

export const load_freguesias_pt = async city => {
    return await reqGET(`${Hosts.SIMCore_API}/countries/pt/villagesofcity/${city}`)
}

export const get_vat_info = async vat => {
    return await reqGET(`${Hosts.SIMCore_API}/vat/${vat}`)
}


export const select_option_util_fun = (arg, set_fun, field) => {
    set_fun(...[arg.map(k => ({ value: k[field], label: k[field] }))])
}

export const select_regist_util_fun = (arg, field) => {
    return arg[0][field]
}


export const obter_cidades_por_distrito = (distrito, set_fun) => load_cities_of_district_pt(distrito).then(res => select_option_util_fun(res.data, set_fun, 'langpt_cc'))

export const obter_distrito_por_cidade = (cidade) => load_district_of_city_pt(cidade).then(res => { return select_regist_util_fun(res.data, 'langpt_dt') })

export const obter_freguesias_por_cidade = (cidade, set_fun) => load_freguesias_pt(cidade).then(res => select_option_util_fun(res.data, set_fun, 'langpt_fr'))

export const obter_paises_em_pt = set_fun => load_countries_pt().then(res => select_option_util_fun(res.data, set_fun, 'langpt'))
export const obter_paises_em_en = set_fun => load_countries_en().then(res => select_option_util_fun(res.data, set_fun, 'langen'))
export const obter_paises_by_lang = (set_fun, lang) => load_countries(lang).then(res => select_option_util_fun(res.data, set_fun, 'lang' + lang))

export const obter_distritos_pt = set_fun => load_districts_pt().then(res => select_option_util_fun(res.data, set_fun, 'langpt_dt'))


export const passwordHash = password => crypto.createHash('md5').update(password).digest("hex")
export const gerarPassword = () => {
    return Math.random().toString(36).slice(-10);
}

export const pattern_vat =
    '^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$'

export const pattern_email = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';

export const set_language = (lang) => {
    localStorage.setItem('lang', lang);
}

export const content_language = [
    {
        id: '1',
        code: 'pt'
    },
    {
        id: '2',
        code: 'en'
    }
];

export const replace_slug_string = (string) => {

    let array_search = ['á', 'à', 'ã', 'â', 'ó', 'ò', 'õ', 'ô', 'é', 'è', 'ê', 'í', 'ì', 'î', 'ú', 'ù', 'û', 'ç', 'ö']
    let array_replace = ['a', 'a', 'a', 'a', 'o', 'o', 'o', 'o', 'e', 'e', 'e', 'i', 'i', 'i', 'u', 'u', 'u', 'c', 'o']

    string = string.toLowerCase()
    array_search.forEach((el, k) => {
        string = string.replaceAll(el, array_replace[k])
    })
    string = string.replace(/[^a-zA-Z0-9 -]/g, '')
    string = string.replaceAll(' ', '-')

    return string
}


// INTERFACE CHECKING
export const check_interface = (data_field, interface_field) => data_field === undefined ? interface_field : data_field


// REPO UTILS


export const repo_base_link = (resource) => Hosts.REPO + "static/assets/" + resource + "/";

export const repo_gest_link = (resource) => Hosts.REPO + "static/gest/assets/" + resource + "/";

export const repo_favicon_link = (resource) => repo_base_link("favicon") + resource;
export const repo_logo_link = (resource) => repo_base_link("logo") + resource;
export const repo_img_link = (resource) => repo_base_link("img") + resource;
export const repo_banner_link = (resource) => repo_base_link("banner") + resource;


export const repo_menu_icon_link = (resource) => repo_gest_link("menu_icon") + resource;
export const repo_icons_link = (resource) => repo_gest_link("icons") + resource;


export const handle_compressed_image_upload = (file, set_fun) => {

    //const file = e.target.files[0];
    // QUEM ALTERAR A EXTENSION TEM QUE ALTERAR AQUI TAMBEM
    const name = file.name.split('.')[0] + '.webp'
    //console.log('handleCompressedUpload info FILE:', file);
    Resizer.default.imageFileResizer(
        file, // the file from input
        1920, // width
        1920, // height
        "WEBP", // compress format WEBP, JPEG, PNG
        90, // quality
        0, // rotation
        (uri) => {
            console.log('handleCompressedUpload info:', uri);
            //set_dados(dados.current.info.profile_photo = uri)
            uri.name = name
            set_fun(uri)
        },
        "blob", // blob or base64 default base64
        //1920, // width
        //1920, // height
    )
}

/*
module.exports = {
    reqGET,
    reqPOST,
    reqPUT,
    reqDELETE,
    reqFILE,

    obter_cidades_por_distrito,
    obter_distrito_por_cidade,
    obter_freguesias_por_cidade,
    obter_paises_em_pt,
    obter_distritos_pt,



    get_vat_info,

    passwordHash,
    gerarPassword,

    pattern_vat,
    pattern_email,

}*/